import React, {Component} from "react";
import {Button} from "react-bootstrap";
import {PAGES} from "../../scripts/constants";

class Beneficiary extends Component {

  pageBtnClicked = (nextPage) => {
    this.props.updatePage(nextPage);
  };

  render() {
    return (
      <div className={'pageContentContainer'}>
        <div style={{alignSelf: 'flex-end', width: '100%', textAlign: 'center', paddingBottom: '1em'}}>
          <h5 style={{color: 'white'}}>
            TODO: Beneficiary Page
          </h5>
          <Button variant={'secondary'} className={'nsre-button'} style={{marginRight: '10px'}}
                  onClick={() => this.pageBtnClicked(PAGES.pageOwner)}>Back</Button>
          <Button variant={'primary'} className={'nsre-button'}
                  onClick={() => this.pageBtnClicked(PAGES.pagePayment)}>Next</Button>
        </div>
      </div>
    );
  }

}

export default Beneficiary;
